import React, { createContext, useContext } from "react";

const TableHeaderContext = createContext(false);

const TableContainer = React.forwardRef(function TableContainer(
  { className = "", children, ...props },
  ref,
) {
  const classes = ["w-full overflow-x-auto", className].filter(Boolean).join(" ");

  return (
    <div ref={ref} className={classes} {...props}>
      {children}
    </div>
  );
});

const Table = React.forwardRef(function Table(
  { className = "", children, ...props },
  ref,
) {
  const classes = [
    "w-full min-w-full divide-y divide-gray-200 text-left text-sm dark:divide-gray-700",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <table ref={ref} className={classes} {...props}>
      {children}
    </table>
  );
});

const TableHeader = React.forwardRef(function TableHeader(
  { className = "", children, ...props },
  ref,
) {
  const classes = ["bg-gray-50 dark:bg-gray-900", className].filter(Boolean).join(" ");

  return (
    <TableHeaderContext.Provider value={true}>
      <thead ref={ref} className={classes} {...props}>
        {children}
      </thead>
    </TableHeaderContext.Provider>
  );
});

const TableBody = React.forwardRef(function TableBody(
  { className = "", children, ...props },
  ref,
) {
  const classes = ["divide-y divide-gray-100 dark:divide-gray-700", className]
    .filter(Boolean)
    .join(" ");

  return (
    <tbody ref={ref} className={classes} {...props}>
      {children}
    </tbody>
  );
});

const TableRow = React.forwardRef(function TableRow(
  { className = "", children, ...props },
  ref,
) {
  const classes = ["align-top", className].filter(Boolean).join(" ");

  return (
    <tr ref={ref} className={classes} {...props}>
      {children}
    </tr>
  );
});

const TableCell = React.forwardRef(function TableCell(
  { className = "", children, ...props },
  ref,
) {
  const inHeader = useContext(TableHeaderContext);
  const Comp = inHeader ? "th" : "td";
  const classes = [
    inHeader
      ? "px-4 py-3 text-xs font-semibold uppercase tracking-wide text-gray-600 dark:text-gray-300"
      : "px-4 py-3 text-sm text-gray-700 dark:text-gray-200",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <Comp ref={ref} className={classes} {...props}>
      {children}
    </Comp>
  );
});

export { Table, TableBody, TableCell, TableContainer, TableHeader, TableRow };
